import React from 'react';
import { Box } from '@skin-seoul/design-system';

export function BMSMGradient() {
  return (
    <Box
      position="absolute"
      bottom="-68.99%"
      left="-59.22%"
      right="-3.63%"
      top="-29.46%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box flexShrink={0} height="583px" transform="rotate(90deg)" width="257.985px">
        <Box position="relative" width="full" height="full">
          <Box position="absolute" bottom="-12.35%" left="-27.91%" right="-27.91%" top="-12.35%">
            <svg width="100%" height="100%" fill="none" preserveAspectRatio="none" viewBox="0 0 402 727">
              <g filter="url(#filter0_f_gradient)" id="BMSM Gradient">
                <path
                  d="M175.013 417.136C119.35 445.742 77.1205 295.872 72 263.224V655H329.985V72C308.749 253.896 230.676 388.53 175.013 417.136Z"
                  fill="url(#paint0_linear_gradient)"
                />
              </g>
              <defs>
                <filter
                  colorInterpolationFilters="sRGB"
                  filterUnits="userSpaceOnUse"
                  height="727"
                  id="filter0_f_gradient"
                  width="401.985"
                  x="0"
                  y="0"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                  <feGaussianBlur result="effect1_foregroundBlur_gradient" stdDeviation="36" />
                </filter>
                <linearGradient
                  gradientUnits="userSpaceOnUse"
                  id="paint0_linear_gradient"
                  x1="200.992"
                  x2="200.992"
                  y1="269.443"
                  y2="604.923"
                >
                  <stop stopColor="#1500FF" />
                  <stop offset="1" stopColor="#B28FFF" />
                </linearGradient>
              </defs>
            </svg>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
